import { connect } from '../../../../../common/react-redux';
import { featureOn } from '../../../../../common/util/featureCheck';
import { NewItemAnalysis as NewItemAnalysisPresenter } from './presenter';
function mapStateToProps(_state) {
  return {
    afsFlags: {
      formulaEnabled: featureOn('ia_formula_afs'),
      matchingEnabled: featureOn('ia_matching_afs'),
      orderingEnabled: featureOn('ia_ordering_afs'),
      hotSpotEnabled: featureOn('ia_hot_spot_afs'),
      categorizationEnabled: featureOn('ia_categorization_afs'),
      trueFalseEnabled: featureOn('ia_true_false_afs'),
      choiceEnabled: featureOn('ia_choice_afs'),
      multiAnswerEnabled: featureOn('ia_multi_answer_afs'),
      fillInTheBlankEnabled: featureOn('ia_rich_fill_blank_afs'),
      essayEnabled: featureOn('ia_essay_afs'),
      fileUploadEnabled: featureOn('ia_file_upload_afs'),
      numericEnabled: featureOn('ia_numeric_afs')
    }
  };
}
var NewItemAnalysis = connect(mapStateToProps)(NewItemAnalysisPresenter);
export default NewItemAnalysis;